import React, { createContext } from "react";
import useAuth from "src/queries/useAuth";
import Loading from "./Loading";
export const AuthContext = createContext(undefined);
const Provider = AuthContext.Provider;
const Auth = ({ children }) => {
    const { data: auth, isLoading } = useAuth();
    if (isLoading) {
        return React.createElement(Loading, null);
    }
    return React.createElement(Provider, { value: auth }, children);
};
export default Auth;
